<template>
    <div class="content is-large">
        <h1>Our Leadership</h1>
        <p>Creek Coding is managed by a Board of Directors with a diverse set of skillsets and backgrounds.</p>
        <ul>
            <!-- <li><b><a href="https://github.com/nguyenadam" target="_blank">Adam Nguyen</a></b> - Director of Curriculum and Instruction</li>
            <li><b><a href="https://jchacko.dev" target="_blank">Jonathan Chacko</a></b> - Director of Operations</li>
            <li><b>Josh Diaz</b> - Director of Innovation</li>
            <li><b><a href="https://github.com/KaytchJam" target="_blank">Kaylan Tchamdjou</a></b> - Director of Design</li>
            <li><b>George Osipov</b> - Director of Procurement and Sourcing</li>
            <li><b>Jalan Rivers</b> - Director of Marketing and Python Curriculum Manager</li> -->
            
            <li><b>Michael Davydov</b>- HackClubSCHS: Operations. Specialties include C based languages, Game Engines, Java, Python.</li>
            <li><b>Justin Impelman</b>- HackClubSCHS: Cirriculum. Specialties include Java, Python.</li>
            <li><b>Alan Abraham</b>- HackClubWMS: Director. Specialties include Website devlopment, Javascript, HTML. </li>
            <li><b>Jay Robison</b>- HackClubSCHS: Projects. Specialties - Java, Python.</li>


        </ul>
    </div>
</template>

<script>
    export default {
        name: "Leadership"
    }
</script>

<style scoped>

</style>
